module.exports = __webpack_public_path__ + "img/base.c7dbe262.png";